module.exports = __webpack_public_path__ + "static/media/co-funded-by-EU.3de541c5.png";